//
//
//

export default {
  /*
   ** programmatically start the loader so we force the page to take x2seconds to load
   */
  data() {
    return {
      internalCreationId: Math.random(),
      internalName: 'index.vue',
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$nuxt.$loading.start(this.internalCreationId, this.internalName)
      setTimeout(() => this.$nuxt.$loading.finish(this.internalCreationId, this.internalName), 2000)
    })
  },
}
